module.exports = __webpack_public_path__ + "static/img/mailmark.b5e7e77.png";


//////////////////
// WEBPACK FOOTER
// ./static/styles/mailkit/img/mailmark.png
// module id = Shmp
// module chunks = 1